(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  const toast = (message) => {
    const element = $('#ThemeToast');
    if (!element) return;
    element.textContent = message;
    element.classList.add('is-visible');
    window.clearTimeout(element.toastTimer);
    element.toastTimer = window.setTimeout(() => element.classList.remove('is-visible'), 3200);
  };

  const mobileNav = $('#MobileNav');
  let mobileNavTrigger = null;
  const setMobileNav = (open) => {
    if (!mobileNav) return;
    if (open) mobileNavTrigger = document.activeElement;
    mobileNav.classList.toggle('is-open', open);
    mobileNav.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('menu-open', open);
    $('[data-mobile-menu-toggle]')?.setAttribute('aria-expanded', String(open));
    if (open) window.setTimeout(() => $('[data-mobile-menu-close]', mobileNav)?.focus(), 60);
    if (!open && mobileNavTrigger instanceof HTMLElement) mobileNavTrigger.focus({ preventScroll: true });
  };
  $$('[data-mobile-menu-toggle]').forEach((button) => button.addEventListener('click', () => setMobileNav(!mobileNav?.classList.contains('is-open'))));
  $$('[data-mobile-menu-close]').forEach((button) => button.addEventListener('click', () => setMobileNav(false)));
  mobileNav?.addEventListener('click', (event) => { if (event.target === mobileNav) setMobileNav(false); });

  const searchDrawer = $('#SearchDrawer');
  const setSearch = (open) => {
    if (!searchDrawer) return;
    searchDrawer.classList.toggle('is-open', open);
    searchDrawer.setAttribute('aria-hidden', String(!open));
    if (open) window.setTimeout(() => $('input[type="search"]', searchDrawer)?.focus(), 50);
  };
  $$('[data-search-toggle]').forEach((button) => button.addEventListener('click', () => setSearch(!searchDrawer?.classList.contains('is-open'))));
  searchDrawer?.addEventListener('click', (event) => { if (event.target === searchDrawer) setSearch(false); });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setMobileNav(false);
    setSearch(false);
  });

  $$('[data-media-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const root = button.closest('[data-product-media]');
      if (!root) return;
      $$('[data-media-item]', root).forEach((item) => item.classList.toggle('is-active', item.dataset.mediaItem === button.dataset.mediaThumb));
      $$('[data-media-thumb]', root).forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
    });
  });

  $$('[data-quantity]').forEach((root) => {
    const input = $('input', root);
    $$('button', root).forEach((button) => button.addEventListener('click', () => {
      const next = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(button.dataset.quantityChange || 0));
      input.value = next;
    }));
  });

  $$('[data-product-root]').forEach((root) => {
    const variantsNode = $('[data-product-variants]', root);
    const idInput = $('input[name="id"]', root);
    const submit = $('[data-add-to-cart]', root);
    const price = $('[data-product-price]', root);
    const compare = $('[data-product-compare]', root);
    const discount = $('[data-product-discount]', root);
    const mpInstallment = $('[data-product-mp-installment]', root);
    const sku = $('[data-product-sku]', root);
    if (!variantsNode || !idInput) return;
    const variants = JSON.parse(variantsNode.textContent);
    const financingFee = Number(root.dataset.financingFeePercent || document.documentElement.dataset.mypcFinancingFee || 9.65);
    const mpInstallments = Math.max(1, Number(root.dataset.mpInstallments || document.documentElement.dataset.mypcMpInstallments || 12));
    const moneyFormat = root.dataset.moneyFormat || '${{amount_no_decimals}}';

    const formatMoney = (cents) => {
      const amount = Math.round(cents / 100).toLocaleString('es-CL');
      return moneyFormat.includes('amount_no_decimals_with_comma_separator')
        ? moneyFormat.replace('{{amount_no_decimals_with_comma_separator}}', amount)
        : moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };

    const update = () => {
      const selected = $$('[data-option-position]', root).reduce((values, input) => {
        if (input.checked) values[Number(input.dataset.optionPosition) - 1] = input.value;
        return values;
      }, []);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        idInput.value = '';
        submit.disabled = true;
        submit.textContent = 'No disponible';
        return;
      }
      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
        compare.hidden = !(variant.compare_at_price > variant.price);
      }
      if (discount) discount.textContent = formatMoney(Math.round(variant.price * (100 - financingFee) / 100));
      if (mpInstallment) mpInstallment.textContent = formatMoney(Math.round(variant.price / mpInstallments));
      if (sku) sku.textContent = variant.sku ? `SKU: ${variant.sku}` : '';
      if (variant.featured_media) {
        const thumb = $(`[data-media-thumb="${variant.featured_media.id}"]`, root);
        thumb?.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
    };

    $$('[data-option-position]', root).forEach((input) => input.addEventListener('change', update));
    update();
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.product-quick-link[href^="#"]');
    if (!link) return;
    const target = document.querySelector(link.hash);
    if (!target) return;
    event.preventDefault();

    const start = window.scrollY;
    const destination = Math.max(0, target.getBoundingClientRect().top + start - 100);
    const distance = destination - start;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      window.scrollTo(0, destination);
      window.history.replaceState(null, '', link.hash);
      return;
    }

    const duration = Math.min(2600, Math.max(1600, Math.abs(distance) * 0.75));
    const startedAt = performance.now();
    const previousScrollBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    const easeInOutCubic = (progress) => progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;

    const scrollFrame = (now) => {
      const progress = Math.min(1, (now - startedAt) / duration);
      window.scrollTo(0, start + distance * easeInOutCubic(progress));
      if (progress < 1) {
        window.requestAnimationFrame(scrollFrame);
        return;
      }
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
      window.history.replaceState(null, '', link.hash);
    };
    window.requestAnimationFrame(scrollFrame);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-add-to-cart]');
    if (!button || button.disabled) return;

    const form = button.closest('form[data-ajax-product-form]');
    if (!form) return;
    event.preventDefault();

    const original = button.textContent.trim();
    const isCrossSell = form.classList.contains('product-cross-sell__form');
    const refreshCartAfterAdd = Boolean(form.closest('.mypc-cart-recommendations'));
    const shopRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

    button.disabled = true;
    button.classList.remove('is-added');
    button.classList.add('is-adding');
    button.textContent = 'Agregando…';

    try {
      const response = await fetch(`${shopRoot}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'No pudimos agregar el producto.');
      }

      const cartResponse = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('El producto se agregó, pero no pudimos actualizar el contador.');
      const cart = await cartResponse.json();
      $$('[data-cart-count]').forEach((count) => {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      });

      button.classList.remove('is-adding');
      button.classList.add('is-added');
      button.textContent = 'Agregado ✓';
      toast(isCrossSell
        ? 'Complemento agregado. Puedes seguir viendo tu PC.'
        : 'Producto agregado al carrito.');
      document.dispatchEvent(new CustomEvent('mypc:cart-ui-added', {
        detail: { cartCount: cart.item_count, source: isCrossSell ? 'cross_sell' : 'product' }
      }));

      if (refreshCartAfterAdd) {
        window.setTimeout(() => window.location.reload(), 550);
        return;
      }

      window.setTimeout(() => {
        button.classList.remove('is-added');
        button.textContent = original;
        button.disabled = false;
      }, 1800);
    } catch (error) {
      button.classList.remove('is-adding', 'is-added');
      button.textContent = original;
      button.disabled = false;
      toast(error.message || 'Ocurrió un error. Intenta nuevamente.');
    }
  });

  $('[data-sort-by]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.assign(url.toString());
  });
  $('[data-mobile-filters]')?.addEventListener('click', () => $('.facets')?.classList.toggle('is-mobile-open'));
})();
